import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const getPrivateLibraryCurrent = state => state.libraries.current

const adminRootSelector = createSelector(
	[getPrivateLibraryCurrent],
	current => ({
		folders: current.folders,
		modal_title: current.folderUID === 0 ? localize('add_to_folder_title') : localize('add_to_subfolder_title'),
		createNewText: current.folderUID === 0 ? localize('add_to_folder_new_folder_link') : localize('add_to_subfolder_new_folder_link'),
	})
)

export default adminRootSelector
